const FILTER_KEYS = ["country", "state", "city", "language", "category"];

export const buildFilterParams = (search) => {
  const qs = new URLSearchParams(search);
  const params = new URLSearchParams();

  FILTER_KEYS.forEach((k) => {
    const v = qs.get(k);
    if (v !== null && v !== "") params.set(k, v);
  });

  return params;
};